type StatCardProps = {
  title: string;
  description: string;
};

export const StatCard = ({ title, description }: StatCardProps) => {
  return (
    <div className="flex flex-col items-center justify-center rounded-[24px] lg:rounded-[32px] border-[1.5px] border-white/90 bg-[linear-gradient(135deg,rgba(255,255,255,0.22)_0%,rgba(255,255,255,0.08)_45%,rgba(255,255,255,0.16)_100%)] backdrop-blur-md shadow-[inset_0_1px_0_rgba(255,255,255,0.35)] px-5 xl:px-10 py-8 xl:py-0 xl:h-[262px]">
      <div className="text-white font-medium leading-tight tracking-[-1px] text-[24px] lg:text-[32px] xl:text-[34px] 2xl:text-[40px]">
        {title}
      </div>
      <div className="mt-[12px] lg:mt-5 max-w-[360px] text-white/90 text-[15px] xl:text-[20px] leading-[1.4]">
        {description}
      </div>
    </div>
  );
};
